import { defineComponent as _defineComponent } from 'vue'
import { TanstackQueryDevtoolsPanel } from '@tanstack/query-devtools';
import { onlineManager, QueryClient, useQueryClient } from '@tanstack/vue-query';
import { onMounted, onScopeDispose, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VueQueryDevtoolsPanel',
  props: {
    client: null
  },
  setup(__props: any) {

const props = __props as {client: QueryClient};


const client = props.client || useQueryClient()
const panel = ref<null| HTMLElement>()
const queryDevtoolsPanel = new TanstackQueryDevtoolsPanel({
    client,
    queryFlavor: 'Vue Query',
    version: '5',
    onlineManager,
    onClose() {
        queryDevtoolsPanel.unmount()
    },
});

onMounted(() => {
    if (panel.value) {
        queryDevtoolsPanel.mount(panel.value)
    }
})

onScopeDispose(() => {
  queryDevtoolsPanel.unmount()
})


return { __sfc: true,props, client, panel, queryDevtoolsPanel }
}

})